import { Form, Input, Button } from "semantic-ui-react";

import { validateBr } from "js-brasil";
import useForm from "../../hooks/useForm";
import useApiFiliado from "../../hooks/useApiFiliado";
import MessageErrorsValidation from "../../components/MessageErrorsValidation";
import MaskedInput from "react-text-mask";

function StepDocumentos({
  dadosPedido,
  setDadosPedido,
  nextStep,
  previousStep,
}) {
  const { data: zonas } = useApiFiliado(
    `/public/zonas-eleitorais-municipio/${dadosPedido.municipioFiliacao}`
  );

  const nextWithValidation = () => {
    setDadosPedido({
      ...dadosPedido,
      cpf: data.cpf.replace(/\D/g, ""),
      titulo: data.titulo.replace(/\D/g, ""),
      zona: data.zona,
      secao: data.secao,
    });
    nextStep();
  };

  const validations = {
    cpf: {
      required: {
        value: true,
        message: "Informe seu CPF",
      },
      custom: {
        isValid: (value) => value && validateBr.cpf(value),
        message: "Informe um CPF válido",
      },
      filter: {
        pattern: /\D/g,
      },
    },
    titulo: {
      required: {
        value: true,
        message: "Informe seu título de eleitor",
      },
      custom: {
        isValid: (value) => validateBr.titulo(value),
        message: "Informe um título de eleitor válido",
      },
      filter: {
        pattern: /\D/g,
      },
    },
    zona: {
      required: {
        value: true,
        message: "Informe a sua zona eleitoral",
      },
    },
    secao: {
      required: {
        value: true,
        message: "Informe a sua seção eleitoral",
      },
      filter: {
        pattern: /\D/g,
      },
    },
  };

  const { data, handleChange, handleSubmit, handleBlur, errors } = useForm(
    validations,
    dadosPedido,
    nextWithValidation
  );

  const getOptionsZonas = () => {
    let options = [];

    options = zonas.map((s) => ({
      key: s.numeroZonaEleitoral,
      value: s.numeroZonaEleitoral,
      text: s.numeroZonaEleitoral,
    }));

    options.unshift({key: -1});

    return options;
  };

  return (
    <>
      <Form.Group widths="equal">
        <Form.Input fluid label="CPF" required error={!!errors.cpf}>
          <MaskedInput
            mask={[
              /\d/,
              /\d/,
              /\d/,
              ".",
              /\d/,
              /\d/,
              /\d/,
              ".",
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
            ]}
            onBlur={handleBlur}
            onChange={(e) => handleChange("cpf", e.target.value)}
            defaultValue={data.cpf}
            autoFocus
          />
        </Form.Input>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Input
          fluid
          label="Título de eleitor"
          required
          error={!!errors.titulo}
        >
          <MaskedInput
            mask={[
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ]}
            onBlur={handleBlur}
            onChange={(e) => handleChange("titulo", e.target.value)}
            defaultValue={data.titulo}
            autoFocus
          />
        </Form.Input>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Select
          fluid
          search
          required
          label="Zona eleitoral"
          name="zona"
          id="zona"
          options={getOptionsZonas()}
          error={!!errors.zona}
          defaultValue={data.zona}
          onChange={(e, data) => handleChange("zona", data.value)}
          onBlur={handleBlur}
          width={4}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field
          id="secao"
          required
          name="secao"
          control={Input}
          label="Seção eleitoral"
          type="number"
          onBlur={handleBlur}
          error={!!errors.secao}
          defaultValue={data.secao}
          onChange={(e, data) => handleChange("secao", data.value)}
        />
      </Form.Group>
      <MessageErrorsValidation errors={errors} />
      <Button className="buttonAcaoMetade" onClick={previousStep} secondary>
        Voltar
      </Button>
      <Button className="buttonAcaoMetade" onClick={handleSubmit} primary>
        Continuar
      </Button>
    </>
  );
}

export default StepDocumentos;
